import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";
import { useSearchParams } from "react-router-dom";
import Moment from "react-moment";
import Styles from "Styles/Styles.module.css";
import ReactPaginate from "react-paginate";
import { OrdersTypes } from "./Types";
import { showWarningAlert, showErrorAlert } from "Util/Alerts";
import { get_Orders, GetCampaignCodes, searchOrder } from "Services/Requests";
import { campaignsType } from "Pages/Auth/campaigns/Types";
import useSaveQueryParams from "Hooks/SaveQueryParams";
import useQueryParams from "Hooks/usequeryParams";
function OrdersComp() {
    let TableHead = ["ORDER ID", "ORDER DATE", "TOTAL", "ORDER TYPE"];
    const navigate = useNavigate();
    const saveQueryParams = useSaveQueryParams();
    const getQueryParams = useQueryParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [forcepage, setfocrcepage] = useState(0);
    const [Count, setCount] = useState(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [Orders, setOrders] = useState<OrdersTypes[]>([]);
    const [campaigns, setcampaigns] = useState<campaignsType[]>([]);
    const [Id, setId] = useState("");
    const [status, setStatus] = useState(1);
    const [searchTerm, setSearchTerm] = useState("");
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [url, setUrl] = useState("");
    // const getOrders = async (status: number, page: any) => {};
    const buttons = [
        { label: "Pending", key: 1 },
        { label: "In Transit", key: 2 },
        { label: "Delivered", key: 3 },
    ];
    const getOrders = async (status: number, page: any, campaign_id: any) => {
        try {
            const response = await get_Orders(status, page, campaign_id);
            if (response?.data?.status === 1) {
                setOrders(response?.data?.data);
                setCount(response?.data?.pageCount);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        /*  if (debouncedTerm) {
            SearchOrderApi();
        } else {
            
        } */
        let page = searchParams.get("page") ?? 1;
        let status = searchParams.get("status") ?? "1";
        let campaign_id = searchParams.get("campaign_id");
        let fromDate = searchParams.get("fromDate");
        let toDate = searchParams.get("toDate");
        let search_term = searchParams.get("search_term");

        let body = { page, status, campaign_id, fromDate, toDate, search_term };
        setStatus(Number(status));
        if (search_term) {
            setSearchTerm(search_term);
        }
        if (fromDate) {
            setFromDate(fromDate);
        }
        if (toDate) {
            setToDate(toDate);
        }
        if (campaign_id) {
            setId(campaign_id);
        }
        setfocrcepage(Number(page) - 1);
        SearchOrderApi(body);
    }, []);
    const SearchOrderApi = async (body: any) => {
        setLoading(true);
        // let body = { search_term: searchTerm };
        try {
            const response = await searchOrder(body);
            if (response?.data?.status === 1) {
                setOrders(response?.data?.data);
                setCount(response?.data?.pageCount);
                setUrl(response?.data?.url);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getcampaigns();
    }, []);
    const handlePageChange = (selectedObject: any) => {
        console.log(selectedObject);
        // setcurrentPage(selectedObject.selected);
        // handleFetch();
        let status = searchParams.get("status") ?? 1;
        let campaign_id = searchParams.get("campaign_id");
        if (campaign_id) {
            setSearchParams({
                status: status.toString(),
                page: selectedObject.selected + 1,
                campaign_id: campaign_id,
            });
        } else {
            setSearchParams({
                status: status.toString(),
                page: selectedObject.selected + 1,
            });
        }
        setfocrcepage(selectedObject.selected);
        getOrders(
            Number(status),
            selectedObject.selected + 1,
            campaign_id ? campaign_id : null
        );
        window.scrollTo({ top: 10, behavior: "smooth" });
    };
    const getcampaigns = async () => {
        try {
            const response = await GetCampaignCodes();
            if (response?.data?.status === 1) {
                setcampaigns(response?.data?.data);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };
    const FilterHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setId(e.target.value);
    };
    const filterHandler = () => {
        let body: any = { page: 1, status: status };

        if (Id) {
            body = { ...body, campaign_id: Id };
        }
        if (searchTerm) {
            body = { ...body, search_term: searchTerm };
        }
        if (fromDate && toDate) {
            body = { ...body, fromDate, toDate };
        }
        if (fromDate && !toDate) {
            body = { ...body, fromDate, toDate: fromDate };
        }
        if (!fromDate && toDate) {
            body = { ...body, fromDate: toDate, toDate };
        }
        setfocrcepage(0);
        if (body) {
            saveQueryParams(body);
            SearchOrderApi(body);
        }
    };
    const clearHandler = () => {
        setId("");
        setFromDate("");
        setToDate("");
        setSearchTerm("");
        let body = { page: 1, status: status };
        saveQueryParams(body);
        setfocrcepage(0);
        SearchOrderApi(body);
    };
    return (
        <div className={Styles["Container"]}>
            <header>
                <h3>Orders</h3>
            </header>

            <div className={Styles["action_tabs_orders"]}>
                {buttons.map((item) => (
                    <button
                        className={
                            status == item.key ? Styles["active_tab"] : ""
                        }
                        key={item.key}
                        onClick={() => {
                            searchParams.set("page", "1");
                            searchParams.set("status", String(item.key));
                            setSearchParams(searchParams);
                            setfocrcepage(0);
                            setStatus(item.key);

                            SearchOrderApi({
                                ...getQueryParams,
                                page: "1",
                            });
                        }}>
                        {item.label}
                    </button>
                ))}
            </div>

            <div className={Styles["filter"]}>
                <select value={Id} onChange={(e) => FilterHandler(e)}>
                    <option value="" disabled>
                        Campaign Code
                    </option>
                    {campaigns?.map((item) => (
                        <option value={item.campaign_id}>
                            {item.campaign_code}
                        </option>
                    ))}
                </select>
                <div className={Styles["search"]} style={{ width: "200px" }}>
                    <input
                        type="text"
                        placeholder="Search By Order ID"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
                <div className={Styles["search"]} style={{ width: "200px" }}>
                    <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                </div>
                <div className={Styles["search"]} style={{ width: "200px" }}>
                    <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                </div>
                <button onClick={filterHandler}>Filter</button>
                <button
                    onClick={clearHandler}
                    style={{ backgroundColor: "red", border: "none" }}>
                    Clear
                </button>
                {Orders.length > 0 && (
                    <button
                        onClick={() => window.open(url, "_blank")}
                        style={{
                            backgroundColor: "inherit",
                            border: "1px solid blue",
                            color: "blue",
                        }}>
                        Export
                    </button>
                )}
            </div>
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {Orders.length > 0 ? (
                                Orders?.map((item) => (
                                    <tr
                                        key={item?.order_id}
                                        onClick={() =>
                                            navigate(
                                                `/auth/orders/${item?.order_id}`
                                            )
                                        }>
                                        <td>{item?.order_id}</td>
                                        <td>
                                            <Moment format="DD-MM-YYYY">
                                                {item?.created_at}
                                            </Moment>
                                        </td>

                                        <td>₹ {item?.grand_total}</td>
                                        <td>
                                            {item.payment_type != "Online" ? (
                                                <span className={Styles["cod"]}>
                                                    COD
                                                </span>
                                            ) : (
                                                <span
                                                    className={
                                                        Styles["online"]
                                                    }>
                                                    Online
                                                </span>
                                            )}
                                        </td>
                                        {/*  <td>
                                            <div
                                                className={`${
                                                    Styles["status_text"]
                                                } ${
                                                    item.order_status == 1
                                                        ? Styles["pending"]
                                                        : item.order_status == 2
                                                        ? Styles["in_transit"]
                                                        : item.order_status == 3
                                                        ? Styles["delivered"]
                                                        : Styles["cancelled"]
                                                }`}>
                                                <GoDotFill />
                                                {item.order_status == 1
                                                    ? "Pending"
                                                    : item.order_status == 2
                                                    ? "In Transit"
                                                    : item.order_status == 3
                                                    ? "Delivered"
                                                    : "Cancelled"}
                                            </div>
                                        </td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No Orders Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {Orders?.length > 0 && (
                        <ReactPaginate
                            pageCount={Count}
                            // pageRange={2}
                            forcePage={forcepage}
                            marginPagesDisplayed={2}
                            onPageChange={handlePageChange}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            activeClassName={"active"}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default OrdersComp;
